<!--
  whatsapp-floating-button.vue
  
  2025-05-24: Created WhatsApp floating action button component with dismissable functionality
-->
<template>
  <v-btn
    v-if="shouldShowButton"
    fab
    color="success"
    class="whatsapp-floating-btn"
    :href="whatsappLink"
    target="_blank"
    rel="noopener noreferrer"
    elevation="4"
  >
    <v-icon size="28" color="white">mdi-whatsapp</v-icon>
    <v-btn
      icon
      x-small
      class="dismiss-btn"
      @click.prevent="dismissButton"
      color="white"
    >
      <v-icon x-small color="success">mdi-close</v-icon>
    </v-btn>
  </v-btn>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "WhatsappFloatingButton",
  data() {
    return {
      isDismissed: false,
    };
  },
  computed: {
    ...mapState({
      settings: (state) => state.settingsModule.settings,
    }),
    shouldShowButton() {
      return (
        this.settings?.whatsapp_number &&
        this.settings?.show_whatsapp_link &&
        !this.isDismissed
      );
    },
    isListingPage() {
      return this.$route.path.includes("/listing/");
    },
    whatsappLink() {
      if (!this.settings?.whatsapp_number) return "#";

      const phone = this.settings.whatsapp_number;

      return `https://wa.me/${phone}`;
    },
  },
  methods: {
    dismissButton() {
      this.isDismissed = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-floating-btn {
  position: fixed !important;
  bottom: 24px !important;
  right: 24px !important;
  z-index: 1000 !important;
  width: 48px !important;
  height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;

  .dismiss-btn {
    position: absolute !important;
    top: -20px !important;
    right: -10px !important;
    background-color: white !important;
    width: 20px !important;
    height: 20px !important;
  }

  &:hover {
    transform: scale(1.05);
    transition: transform 0.2s ease-in-out;
  }
}

// Responsive adjustments
@media (max-width: 600px) {
  .whatsapp-floating-btn {
    bottom: 16px !important;
    right: 16px !important;
  }
}
</style>
